<template>
    <div>
        <div class="top_texts">
            <h1>Bedankt voor uw interesse!</h1>
            <h3>Doorloop deze stappen om uw aanmelding compleet te maken.</h3>
        </div>
        <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
        <router-view
            @go_to_step="go_to_step"
            @next_step="go_to_step(parsed_step + 1)"
            @prev_step="go_to_step(parsed_step - 1)"
        ></router-view>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs.vue';

    export default {
        name: 'Signup',
        components: {
            Breadcrumbs,
        },
        props: {
            step: {
                default: 1,
                required: false,
            },
        },
        data() {
            return {
                breadcrumb_steps: [
                    {
                        label: 'Abonnement',
                        step: [1, 2],
                        current: false,
                        previous: false,
                    },
                    {
                        label: 'Gegevens',
                        step: [3, 4],
                        current: false,
                        previous: false,
                    },
                    {
                        label: 'Overeenkomst',
                        step: 5,
                        current: false,
                        previous: false,
                    },
                ],
            };
        },
        computed: {
            parsed_step: (self) => parseInt(self.step || 1, 10),
            next_step: (self) => self.parsed_step + 1,
            breadcrumbs: (self) => self.breadcrumb_steps.map((breadcrumb) => {
                const bc = breadcrumb;
                if (Array.isArray(breadcrumb.step)) {
                    bc.previous = breadcrumb.step[0] < self.parsed_step;
                    bc.current = breadcrumb.step.includes(self.parsed_step);
                } else {
                    bc.previous = breadcrumb.step < self.parsed_step;
                    bc.current = breadcrumb.step === self.parsed_step;
                }
                return bc;
            }),
            all_steps: (self) => {
                const steps = [];
                self.breadcrumb_steps.forEach((breadcrumb) => {
                    if (Array.isArray(breadcrumb.step)) steps.push(...breadcrumb.step);
                    else steps.push(breadcrumb.step);
                });
                return steps.sort();
            },
        },
        watch: {
            step: 'handle_step_change',
        },
        methods: {
            handle_step_change() {
                const self = this;

                const first_step = self.all_steps[0];
                const last_step = self.all_steps[self.all_steps.length - 1];

                if (self.parsed_step < first_step) self.go_to_step(first_step);
                else if (self.parsed_step > last_step) self.go_to_step(last_step);
            },
            go_to_step(step) {
                const self = this;
                self.$router.push({
                    name: self.$route.name,
                    params: {
                        ...self.$route.params,
                        step: String(step || self.next_step),
                    },
                });
            },
        },
        mounted() {
            const self = this;
            self.handle_step_change();
        },
    };
</script>
